import React from 'react';
import indicatifs from '../../utils/indicatifs';
import SelectIndicatifModal from './SelectIndicatifModal';
import {IoIosArrowDown} from 'react-icons/io'
import { useForm } from 'react-hook-form';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth'
import { app } from '../../utils/Firebase';
import ApiController from '../../redux/actions';
import { toast } from 'react-toastify';

const Register = ({setHasAccount,setShowModal}) => {

    const [showIndicatifsModal,setShowIndicaifsModal] = React.useState(false)
    const [isLoading,setIsLoading] = React.useState(false)
    const [isOtpSent,setIsOtpSent] = React.useState(false)
    const [otp,setOtp] = React.useState()
    const [registerData,setRegisterData] = React.useState()

    const [selectedIndicatif,setSelectedIndicatif] = React.useState(indicatifs.filter(item => item.value === 221)[0])

    const {register,formState:{errors},setError,handleSubmit} = useForm()

    const submit = (data) => {
        setIsLoading(true)
        setRegisterData(data)

        ApiController.users.isUserNotRegistered("+"+selectedIndicatif.value+data.telephone)
        .then(res => {
            const verifier = new RecaptchaVerifier('container-recaptcha',{},getAuth(app))
            signInWithPhoneNumber(getAuth(app),"+"+selectedIndicatif.value+data.telephone,verifier)
            .then((result)=>{
                setOtp(result)
                setIsOtpSent(true)
                setIsLoading(false)
            })
            .catch(err => {
                setError('telephone',{message:'numéro de téléphone invalid!'})
                setIsLoading(false)
            })
        })
        .catch(res => {
            setError('telephone',{message:'Ce numéro est déja inscrit!'})
            setIsLoading(false)
        })
    }

    const confirmOTP =(data)=>{
        setIsLoading(true)
        if(otp){
            otp.confirm(data.otp).then((result)=>{
                let user = {
                    ...registerData,
                    telephone : "+" + selectedIndicatif.value + registerData.telephone
                }
                ApiController.users.registerUser(user)
                .then(user =>{
                    setShowModal(false)
                    toast.success('Inscription réuissi',{
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        style:{width:'70vw', right:0,top:'30px',position:'absolute'}
                        })
                })
                .catch(err => console.log(err))
            }).catch(()=>{
                setIsLoading(false)
                setError('otp',{message:'Code de confirmation incorrect!'})
            })
        }
    }


    return (
        <>
        {isOtpSent ? (
                <form className="row login-form" onSubmit={handleSubmit(confirmOTP)}>

                    <div className="col-12 mt-4 text-center">
                        <p className='text-center text-uppercase fw-bold'>Confirmation du code</p>
                        <div className="col-12 mt-3">
                            <p className='text-center'>
                                Vueillez confirmer le code a <span className='fw-bold'>6 chiffres</span> qui vous a été envoyé par SMS au 
                                <br />
                                <span className='fw-bold'>
                                    ( {"+"+ selectedIndicatif.value + registerData?.telephone} )
                                </span>
                            </p>
                            <div className="mt-4">
                                <input {...register('otp',{required:'Veuillez saisir le code de confirmtion'})} type="number" placeholder='code de confirmation' className='input-number input-otp' />
                                {errors.otp && <p className='error-msg'>{errors.otp.message}</p>}
                            </div>
                        </div>
                        <div className="col-12 mt-4">
                            <button disabled={isLoading} className='submit-btn row p-0 m-0 align-items-center'>
                                <div className="col-2"></div>
                                <div className="col-8">
                                    Confirmer
                                </div>
                                <div className="col-2 pt-1">
                                    {isLoading && <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>}    
                                </div>
                            </button>
                        </div>
                    </div>
                </form>
            ):(
             
            <form className="row login-form" onSubmit={handleSubmit(submit)}>
                <div className="col-12 mt-4 text-start">
                    <p className='text-center text-uppercase fw-bold'>Créer un nouveau compte</p>
                    
                    <div className="col-12 mt-3">
                        <label >Prénom</label>
                        <input {...register('prenom',{required:'Veuillez saisir votre prénom'})} type="text" placeholder='Prénom' className='input-number' />
                        {errors.prenom && <p className='error-msg'>{errors.prenom.message}</p>}
                    </div>

                    <div className="col-12 mt-3">
                        <label >Nom</label>
                        <input {...register('nom',{required:'Veuillez saisir votre prénom'})} type="text" placeholder='Nom' className='input-number' />
                        {errors.nom && <p className='error-msg'>{errors.nom.message}</p>}
                    </div>
                    
                    <div className="col-12 mt-3">
                        <label className=''>indicatif:</label>
                        <button type='button' className='select-btn' onClick={()=>setShowIndicaifsModal(true)}>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <img src={selectedIndicatif.imgSrc} alt="..." />
                                </div>
                                <div className="col-9 text-start">
                                    <span className='fw-bold me-4'>( +{selectedIndicatif.value} )</span>
                                    <span>{selectedIndicatif.label}</span>
                                </div>
                                <div className="col-2 text-start">
                                    <IoIosArrowDown size={25}/>
                                </div>
                            </div>
                        </button>
                    </div>
                    <div className="col-12 mt-3">
                        <label >Numéro de téléphone</label>
                        <input {...register('telephone',{required:'Veuillez saisir un numéro de téléphone'})} type="number" placeholder='771234567' className='input-number' />
                        {errors.telephone && <p className='error-msg'>{errors.telephone.message}</p>}
                    </div>
                    <div className="col-12 mt-2">
                        <div id='container-recaptcha'></div>
                    </div>
                    <div className="col-12 mt-4">
                        <button disabled={isLoading} className='submit-btn row p-0 m-0 align-items-center'>
                            <div className="col-2"></div>
                            <div className="col-8">
                                Inscription
                            </div>
                            <div className="col-2 pt-1">
                                {isLoading && <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>}    
                            </div>
                        </button>
                    </div>
                    
                    <p className='text-center mt-3'>Vous avez déja un compte?</p>
                    <div className='text-center mb-5'>
                        <button onClick={()=>setHasAccount(true)} type='button' className='text-center fw-bold  text-uppercase text register'>Connectez-vous</button>
                    </div>
                </div>
                <SelectIndicatifModal
                    showModal={showIndicatifsModal} 
                    setShowModal={setShowIndicaifsModal} 
                    selectedItem={selectedIndicatif} 
                    setSelectedItem={setSelectedIndicatif}
                    />
            </form>
            )
        }   
        </>
    );
};

export default Register;